import { render, staticRenderFns } from "./invoice-register.vue?vue&type=template&id=3a8a0400&scoped=true"
import script from "./invoice-register.vue?vue&type=script&lang=js"
export * from "./invoice-register.vue?vue&type=script&lang=js"
import style0 from "./invoice-register.vue?vue&type=style&index=0&id=3a8a0400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a0400",
  null
  
)

export default component.exports